import { IPhongUuTienBuoiActionTypes } from "../../action-types/category/IPhongUuTienBuoiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongUuTienBuoiReducer } from "../../reducer-model/category/IPhongUuTienBuoiReducer";

const initState: IPhongUuTienBuoiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  phongUuTienBuois: [],
};
export const phongUuTienBuoiReducer = (
  state: IPhongUuTienBuoiReducer = initState,
  action: IPhongUuTienBuoiActionTypes
): IPhongUuTienBuoiReducer => {
  switch (action.type) {
    case "PHONG_UU_TIEN_BUOI_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "PHONG_UU_TIEN_BUOI_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, phongUuTienBuois: action.payload };
    case "PHONG_UU_TIEN_BUOI_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_UU_TIEN_BUOI_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, phongUuTienBuoiEditing: action.payload };
    case "PHONG_UU_TIEN_BUOI_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "PHONG_UU_TIEN_BUOI_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "PHONG_UU_TIEN_BUOI_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "PHONG_UU_TIEN_BUOI_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_UU_TIEN_BUOI_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "PHONG_UU_TIEN_BUOI_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "PHONG_UU_TIEN_BUOI_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
